<template>
  <b-form-group :label="label">
    <p v-if="image">
      <img :alt="image.name" :src="image.url" class="img img-thumbnail" width="100"><br>
      <a href="#" v-if="editable" @click.prevent="clearImage">Vervang afbeelding</a>
    </p>
    <b-form-file v-else v-model="file" :disabled="!editable" placeholder="Selecteer een bestand..."></b-form-file>
  </b-form-group>
</template>

<script>
  export default {
    name: "ImageUpload",

    props: {
      label: {
        type: String,
        required: true
      },
      editable: {
        type: Boolean,
        required: false,
        default: false
      },
      image: {
        required: false
      }
    },

    data() {
      return {
        file: null,
      }
    },

    methods: {
      clearImage() {
        this.$emit('clear');
      }
    },

    watch: {
      file(val) {
        this.$emit('input', val);
      }
    },
  }
</script>

<style scoped>

</style>
